module.exports = __webpack_public_path__ + "img/schemes.22ccd172.png";